import { useQuery } from "@tanstack/react-query";

import type { IndeedCampaignIntegrationsResponse } from "./types";
import { campaignIntegrationQueryKeys } from "../query-keys";

import { instance } from "@/lib/axios/instance";

type UseIndeedCampaignIntegrationsParams = {
  clientId: string | undefined;
  search?: string;
  statusFilter?: string;
  page?: number;
  pageSize?: number;
};

export function useIndeedCampaignIntegrations({
  clientId,
  search,
  statusFilter,
  page = 1,
  pageSize = 50,
}: UseIndeedCampaignIntegrationsParams) {
  return useQuery({
    queryKey: campaignIntegrationQueryKeys.overviewList({
      integrationName: "indeed",
      clientId: clientId ?? "",
      search,
      statusFilter,
      page,
      pageSize,
    }),
    queryFn: async () => {
      const response = await instance.get<{
        data: IndeedCampaignIntegrationsResponse[];
        page: number;
        pageSize: number;
        totalRecords: number;
      }>("/api/v2/Integrations/indeed/campaigns/overview", {
        params: {
          clientId,
          search: search || undefined,
          statusFilter: statusFilter || undefined,
          page,
          pageSize,
        },
      });

      return response.data.data[0] ?? null;
    },
    enabled: !!clientId,
  });
}
